import { AppRoutes } from '@constants/app-routes'
import { OrangeLink } from '@ui/links/OrangeLink'

export const config = {
  title: 'Results:',
  subtitle: (
    <>
      The client was thrilled with the final design of the e-courses
      application. The visual design helped to create an engaging and intuitive
      user experience that kept learners motivated and focused throughout the
      course. Feedback from users also indicated that they found the application
      easy to use and navigate.
      <br />
      <br />
      The visual design helped us create an engaging and intuitive platform that
      kept learners motivated and focused throughout the course. The user
      feedback we received proved that the app was easy to use and navigate.
      <br />
      <br />
      The design solution implemented by{' '}
      <OrangeLink href={AppRoutes.aboutUs}>our team</OrangeLink> allowed the
      client to create a consistent visual brand identity that was successfully
      integrated across the rest of their e-learning platforms.
    </>
  ),
  config: [
    {
      id: 1,
      title: '212K',
      subtitle: 'downloads in 4 month',
    },
    {
      id: 2,
      title: '4,9',
      subtitle: 'app store rating',
    },
    {
      id: 3,
      title: '№ 5',
      subtitle: 'position in the e-learning apps rating',
    },
  ],
}
